import { json } from '@codemirror/lang-json';
import { type LanguageSupport, StreamLanguage } from '@codemirror/language';
import { jinja2 } from '@codemirror/legacy-modes/mode/jinja2';
import { yaml } from '@codemirror/legacy-modes/mode/yaml';
import type { Extension } from '@codemirror/state';
import { mustache } from './CodeEditor.mustache';
import type { CodeEditorLanguage } from './CodeEditor.types';

/**
 * Closed map from language key to extension factory.
 * Each factory returns a fresh Extension on every call so reconfiguring the
 * languageCompartment never aliases state across editor instances.
 */
export const codeEditorLanguages: Record<CodeEditorLanguage, () => Extension> =
  {
    json: (): LanguageSupport => json(),
    jinja2: () => StreamLanguage.define(jinja2),
    mustache: () => StreamLanguage.define(mustache),
    yaml: () => StreamLanguage.define(yaml),
  };
